module.exports = __webpack_public_path__ + "static/img/logo-letters-color.3517d28e.svg";